// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--2wlCb","info":"info--30ZWS","uploadButtons":"uploadButtons--2PXZs","uploadComponent":"uploadComponent--3jwdC"};